<user-navigation></user-navigation>

<div id="exerciseConfirmation">
  <section class="h-100">
    <header class="container h-100">
      <div class="d-flex align-items-center justify-content-center h-100">
        <div class="confirmation-body">
          <h4 class="text-center">Continue to Breathing Exercise</h4>
          <p class="text-center mt-3 mt-md-3 mb-5 mb-md-5">Would you like to continue to the 60 second breathing<br>exercise or go back to the homepage?</p>

          <div class="row">
            <div class="col-md-12 d-md-flex justify-content-center align-items-center">
              <button class="btn btn-primary btn-homepage" [routerLink]="['/user/dashboard']" style="width: inherit">Homepage</button>&nbsp;
              <button style="width: inherit"
                class="btn btn-primary btn-exercise"
                [routerLink]="['/user/breathing-exerise/', seriesId, moduleId]"
                [queryParams]="{exercise_active: true}"
              >
                Breath Exercise
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  </section>
</div>

<div class="container-fluid">
  <div class="row no-gutter">
    <div class="col-xl-3 d-none d-sm-none d-md-none d-lg-none d-xl-block">
      <series-navigation></series-navigation>
    </div>
    <div class="col-md-12 col-lg-12 col-xl-9" *ngIf="summary">
      <div class="exercise">
        <div class="white-box mx-2 mx-md-5 mx-lg-5">
          <h2 class="title font-weight-bold">Summary</h2>
          <!-- <p class="points font-weight-bold" *ngIf="modulePoints > 0">
            <i class="fa fa-star"></i> {{ modulePoints }} Points Earned
          </p> -->
          <div class="points mt-2 mt-md-2" *ngIf="modulePoints > 0">
            <img class="badge-icon" src="../../../../assets/images/icons/award_dark.svg">
            <span class="d-inline-block align-middle ml-1 ml-md-1 mr-1 mr-md-1 font-weight-bold points-earned">{{ modulePoints }} Points Earned!</span>
          </div>
          <br>
          <div id="summary">
            <ul>
              <li *ngFor="let data of summary">
                <div class="summary-bullet"><i class="fa fa-dot-circle-o"></i></div>
                <label>{{ data.text }}</label>
              </li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button class="btn btn-primary pull-right mt-3 mt-md-3 mb-3 mb-md-3 mr-3 mr-md-3 submit" (click)="redirectToDashboard()">
                <a>Finish </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Modal Loader -->
  <modal-loader [modalText]="modalText"></modal-loader>

</div>
